import { useRef } from 'react';

import { insertPlaceholder } from '../../../../../util/custom-messages';

/**
 * Inserts placeholders into a text input or textarea at the caret, keeping the
 * caret right after the inserted text. Returns the ref to attach to the field
 * and the insert handler for an InsertVariableDropdown.
 * @param {string} value Current field value.
 * @param {Function} onChange Called with the new value.
 * @returns {{ inputRef: object, onInsert: Function }}
 */
const useInsertAtCaret = (value, onChange) => {
  const inputRef = useRef();

  const onInsert = (placeholder, options) => {
    const { body: newValue, caretPosition } = insertPlaceholder(
      value ?? '',
      placeholder,
      {
        selectionStart: inputRef.current?.selectionStart,
        prepend: !!options?.prepend,
      },
    );

    onChange(newValue);

    if (inputRef.current) {
      inputRef.current.value = newValue;
      inputRef.current.setSelectionRange(caretPosition, caretPosition);
      inputRef.current.focus();
    }
  };

  return { inputRef, onInsert };
};

export default useInsertAtCaret;
